export default {"src":"/_next/static/media/aboutus_testimonails_top.b0f3ae61.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};